export const extractErrorMessage = (error: unknown): string | undefined => {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'object' && error !== null) {
    const jsonString = JSON.stringify(error);
    return jsonString;
  }
};
